<template>
  <div class="apply_used">
    <div class="apply_content">
      <div class="apply_left flex-grow">
        <h2>免费获取30天的产品体验</h2>
        <div class="aplyicon">
          <div class="aplyicon_left">
            <img src="@/assets/img/saas/gongchang.png">
          </div>
          <div class="aplyicon_right">
            <div style="line-height:30px;font-size:15px;font-weight:bold;margin-top:10px"> 新一代智能工厂</div>
            <div style="font-size:14px">为不同规模的企业提供差异化的只能制造云服务</div>
          </div>
        </div>
        <div class="aplyicon"
             style="margin-top:5px">
          <div class="aplyicon_left">
            <img src="@/assets/img/saas/yonghu.png">
          </div>
          <div class="aplyicon_right"
               style="margin-top:5px">
            <div style="line-height:30px;font-size:15px;font-weight:bold;margin-top:10px"> 简单便捷的用户体验</div>
            <div style="font-size:14px">围绕用户具体工作场景，实现简单便捷的操作体验</div>
          </div>
        </div>
        <div class="aplyicon"
             style="margin-top:5px">
          <div class="aplyicon_left">
            <img src="@/assets/img/saas/huojian.png">
          </div>
          <div class="aplyicon_right">
            <div style="line-height:30px;font-size:15px;font-weight:bold;margin-top:10px"> 敏捷响应的用户体系</div>
            <div style="font-size:14px">为企业提供便捷的技术支持和运营服务</div>
          </div>
        </div>
        <div class="aplyicon">
          <div class="aplyicon_left">
            <img src="@/assets/img/saas/zhizao.png">
          </div>
          <div class="aplyicon_right">
            <div style="line-height:30px;font-size:15px;font-weight:bold;margin-top:10px"> 深耕智能制造领域</div>
            <div style="font-size:14px">1800+客户选择的智能制造产品和解决方案</div>
          </div>
        </div>
      </div>
      <!-- 申请体验 -->
      <div class="apply_home flex-shrink">
        <div class="apply_title"
             style="font-size:18px;font-weight:bold;height:45px">申请体验<span style="font-size:12px;font-weight:100;margin-left:10px">免费一对一项目与解决方案咨询服务</span></div>
        <!-- <div class="text-center apply_des"></div> -->
        <el-form label-width="0px"
                 :model="dataForm"
                 :rules="dataRule"
                 :disabled="butLoading"
                 ref="dataForm">
          <el-form-item prop="name">
            <el-input v-model="dataForm.name"
                      placeholder="姓名"
                      :maxlength="20">
              <template slot="prepend">
                <i class="el-icon-user"></i>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="phone">
            <el-input v-model="dataForm.phone"
                      placeholder="手机"
                      :maxlength="13">
              <template slot="prepend">
                <i class="el-icon-phone-outline"></i>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="verificationCode">
            <el-input v-model="dataForm.verificationCode"
                      :maxlength="6"
                      placeholder="短信验证码">
              <template slot="prepend">
                <i class="el-icon-message"></i>
              </template>
              <el-button slot="append"
                         :loading="butLoading"
                         @click.stop="getCode">{{btntxt}}</el-button>
            </el-input>
          </el-form-item>
          <el-form-item prop="companyName">
            <el-input v-model="dataForm.companyName"
                      placeholder="企业名称(选填)"
                      :maxlength="30">
              <template slot="prepend">
                <i class="el-icon-office-building"></i>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="describe">
            <el-input v-model="dataForm.describe"
                      placeholder="需求描述(选填)"
                      :maxlength="100">
              <template slot="prepend">
                <i class="el-icon-office-building"></i>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button style="width: 100%;"
                       type="primary"
                       :loading="butLoading"
                       @click.stop="submitHandle">提交申请</el-button>
          </el-form-item>
        </el-form>
        <div style="color:#ccc;font-size:12px;margin-top:-10px">本网站不会将您的信息分享、售卖租借或交换给任何第三方公司作为销售推广之用</div>
      </div>
    </div>
  </div>
</template>
<script>
import { isMobile } from '@/utils/validate'
export default {
  data () {
    return {
      butLoading: false,
      count: 0,
      btntxt: '获取验证码',
      dataForm: {
        name: '',
        phone: '',
        companyName: '',
        describe: '',
        requestId: '',
        verificationCode: '',
        productName: '' // 产品名称
      }
    }
  },
  computed: {
    dataRule () {
      return {
        name: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        phone: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        verificationCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    this.dataForm.productName = this.$route.query.name
  },
  methods: {
    // 获取验证码
    getCode () {
      if (this.dataForm.phone && isMobile(this.dataForm.phone)) { } else {
        this.$message.warning('请输入正确的手机号')
        return false
      }
      if (this.butLoading || this.count > 0) {
        return false
      }
      this.butLoading = true
      this.dataForm.requestId = ''
      this.$request.get(`/front/consumer/message/getMobileVerificationCode?mobile=${this.dataForm.phone}`)
        .then(res => {
          this.dataForm.requestId = res.requestId || ''
          this.count = 60
          console.log(res)
          this.timer()
        })
        .finally(() => {
          this.butLoading = false
        })
    },
    timer () {
      if (this.count > 0) {
        this.count--
        this.btntxt = this.count + 's后重新获取'
        this.$nextTick(() => {
          setTimeout(this.timer, 1000)
        })
      } else {
        this.count = 0
        this.btntxt = '获取验证码'
      }
    },
    // 提交申请
    submitHandle () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        if (this.dataForm.phone && isMobile(this.dataForm.phone)) { } else {
          this.$message.warning('请输入正确的手机号')
          return false
        }
        if (!this.dataForm.requestId) {
          this.$message.warning('请发送短信')
          return false
        }
        if (this.butLoading) {
          return false
        }
        this.butLoading = true
        this.$http.post(`/front/consumer/message/cloudApplicationUsage`, this.dataForm)
          .then(({ data: res }) => {
            if (res.code !== 0) {
              return false
            }
            this.$message.success('申请成功')
            this.$router.push({
              name: 'saasIndex'
            })
          }).finally(() => {
            this.butLoading = false
          })
      })
    }
  }
}
</script>
<style lang='scss' scoped>
.aplyicon {
  height: 80px;
  width: 100%;
  .aplyicon_left {
    height: 100%;
    width: 80px;
    float: left;
    img {
      height: 100%;
      width: 100%;
    }
  }
  .aplyicon_right {
    height: 100%;
    width: 320px;
    float: left;
  }
}
.apply_used {
  position: fixed;
  width: 100%;
  height: 100%;
  background-image: url("./../../../assets/img/saas/apply-bg.png");
  .apply_content {
    border-radius: 25px;
    margin: 100px auto;
    width: 1000px;
    background-color: #fff;
    display: flex;
    .apply_left {
      padding: 50px;
      h2 {
        color: #1d65a8;
      }
      h3 {
        margin: 0;
      }
    }
  }
  .apply_home {
    padding: 50px;
    width: 480px;
    height: 500px;
    .apply_title {
      font-size: 20px;
      line-height: 30px;
    }
    .apply_des {
      color: #aaa;
      line-height: 20px;
    }
  }
}
</style>
